/* AMP drawer: total unit count, accessibility, and trade-only sample messaging. */
(function () {
  if (window.__ampSCCartCountFix) return;
  window.__ampSCCartCountFix = true;

  var config = document.getElementById('amp-cart-drawer-script');
  var isTradePartner = config && config.getAttribute('data-trade-partner') === 'true';
  var sampleMessagesEnabled = !config || config.getAttribute('data-sample-messages-enabled') !== 'false';
  var freeSampleLimit = 30;
  var remainingMessage = config && config.getAttribute('data-sample-remaining-message') || 'You can add {remaining} more samples for free.';
  var remainingOneMessage = config && config.getAttribute('data-sample-remaining-one-message') || 'You can add {remaining} more sample for free.';
  var limitMessage = config && config.getAttribute('data-sample-limit-message') || "You've hit your {limit} free samples";
  var cart = null;
  var cartVersion = 0;
  var deb = null;

  function apply() {
    var host = document.querySelector('#slidecarthq');
    if (!host) return;

    var overlay = host.querySelector('.slidecarthq-overlay');
    if (overlay) overlay.setAttribute('aria-label', 'Close cart');
    if (!cart) return;

    var count = host.querySelector('.cart-count');
    if (count && count.textContent !== String(cart.item_count)) {
      count.textContent = cart.item_count;
    }

    var message = host.querySelector('.amp-sample-promotion');
    var sampleCount = 0;
    if (isTradePartner && sampleMessagesEnabled) {
      cart.items.forEach(function (item) {
        // Sample eligibility belongs to the cart variant, across all product types.
        if (typeof item.variant_title === 'string' && item.variant_title.indexOf('Sample') !== -1) {
          sampleCount += item.quantity;
        }
      });
    }

    var items = host.querySelector('.items');
    if (!sampleCount || !items) {
      if (message) message.remove();
      return;
    }

    if (!message) {
      message = document.createElement('p');
      message.className = 'amp-sample-promotion';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.setAttribute('aria-atomic', 'true');
    }

    var remaining = Math.max(0, freeSampleLimit - sampleCount);
    var template = sampleCount >= freeSampleLimit
      ? limitMessage
      : remaining === 1 ? remainingOneMessage : remainingMessage;
    var text = template.replace(/\{(remaining|limit)\}/g, function (match, key) {
      return key === 'remaining' ? remaining : freeSampleLimit;
    });
    if (message.textContent !== text) message.textContent = text;

    // AMP's order notice is in custom_html_header, immediately before the items.
    if (message.nextSibling !== items) items.parentNode.insertBefore(message, items);
  }

  function scheduleApply() {
    clearTimeout(deb);
    deb = setTimeout(apply, 0);
  }

  function receiveCart(updatedCart) {
    cartVersion += 1;
    cart = updatedCart;
    scheduleApply();
  }

  function refreshCart() {
    var version = cartVersion;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Unable to load cart');
        return r.json();
      })
      .then(function (updatedCart) {
        // Do not overwrite a newer cart received from AMP while this request ran.
        if (version === cartVersion) receiveCart(updatedCart);
      })
      .catch(function () {});
  }

  // Preserve callbacks installed by other integrations, including their return values.
  ['SLIDECART_LOADED', 'SLIDECART_UPDATED'].forEach(function (name) {
    var previous = window[name];
    window[name] = function (updatedCart) {
      var result;
      if (typeof previous === 'function') result = previous.apply(this, arguments);
      receiveCart(updatedCart);
      return result;
    };
  });

  var previousOpened = window.SLIDECART_OPENED;
  window.SLIDECART_OPENED = function () {
    var result;
    if (typeof previousOpened === 'function') result = previousOpened.apply(this, arguments);
    refreshCart();
    return result;
  };

  function boot() {
    var host = document.querySelector('#slidecarthq');
    if (!host) return false;

    // AMP renders asynchronously; restore the message after its DOM updates.
    // Rendering uses cached cart data so our own DOM changes never trigger fetch loops.
    new MutationObserver(scheduleApply).observe(host, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    apply();
    if (!cart) refreshCart();

    return true;
  }

  if (!boot()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (boot() || ++tries > 60) clearInterval(iv);
    }, 500);
  }
})();
